import type { ComponentProps } from 'react'
import { XIcon } from '../decorative/x-icon'
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from './input-group'

export function ClearableInput({
  onClear,
  disabled,
  readOnly,
  ...props
}: ComponentProps<'input'> & { onClear: () => void }) {
  return (
    <InputGroup data-disabled={disabled}>
      <InputGroupInput {...props} disabled={disabled} readOnly={readOnly} />
      {!!props.value && (
        <InputGroupAddon align="inline-end">
          <InputGroupButton
            aria-label="Clear value"
            disabled={disabled || readOnly}
            onClick={onClear}
          >
            <XIcon />
          </InputGroupButton>
        </InputGroupAddon>
      )}
    </InputGroup>
  )
}
